import { render, staticRenderFns } from "./FulfillmentOrdersCounterChartExtended.vue?vue&type=template&id=9f65cb04&scoped=true"
import script from "./FulfillmentOrdersCounterChartExtended.vue?vue&type=script&lang=js"
export * from "./FulfillmentOrdersCounterChartExtended.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentOrdersCounterChartExtended.vue?vue&type=style&index=0&id=9f65cb04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f65cb04",
  null
  
)

export default component.exports